// extracted by mini-css-extract-plugin
export default {"item-list":"DessertsMobile_item-list__jxyfJ","item":"DessertsMobile_item__VsVOH","category-title":"DessertsMobile_category-title__ReDVF"};